<!--
 * @Description: 
 * @Author: Mankeung
 * @Date: 2021-07-07 10:03:48
 * @LastEditors: Mankeung
 * @LastEditTime: 2021-07-17 16:57:35
-->

<style lang="scss" scoped>
.role {
  display: flex;
  gap: 20px;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;
  &Right {
    flex: 1;
    display: flex;
    overflow-x: hidden;
    flex-direction: column;
    &_Top {
      display: flex;
      gap: 15px;
      .el-input {
        width: auto;
      }
    }
    &_Container {
      margin-top: 20px;
    }
    &_pagenation {
      margin: 40px auto;
    }

    ::v-deep .el-table th,
    ::v-deep .el-table td {
      text-align: center !important;
    }
  }
}
</style>
<template>
  <section>
    <div class="role">
      <div class="roleRight">
        <div class="roleRight_Top">
          <template v-if="searchShow">
            <el-input
                clearable
                v-model="search.searchKey"
                clas="input_search"
                placeholder="搜索关键字"
                @keyup.enter.native="SearchServiceList"
            ></el-input>
            <el-select
                v-model="search.serviceType"
                filterable
                clearable
                placeholder="请选择客服"
            >
              <el-option
                  v-for="item in kefuList"
                  :key="item.enumId"
                  :label="item.enumName"
                  :value="item.enumVal"
              ></el-option>
            </el-select>
            <el-select v-model="search.status" clearable placeholder="请选择">
              <el-option label="正常" value="1"></el-option>
              <el-option label="禁用" value="0"></el-option>
            </el-select>
            <el-button size="medium" type="primary" @click="SearchServiceList"
            >查询</el-button
            >
          </template>

          <el-button
              v-if="addShow"
            size="medium"
            type="primary"
            @click="handleClick('addNext')"
            >新增</el-button
          >
        </div>
        <div class="roleRight_Container public-table-data">
          <el-table
            :data="tableData"
            size="medium"
            border
            style="width: 100%; max-width: 1500px"
            row-key="customerServiceId"
            v-loading="loading"
          >
            <el-table-column fixed label="序号" prop="serviceId"  type="index" width="100">
              <template slot-scope="scope">
                <span>{{
                  (page.pageNo - 1) * page.pageSize + scope.$index + 1
                }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="serviceTypeName" label="类型">
            </el-table-column>
            <el-table-column prop="name" label="名称"> </el-table-column>
            <el-table-column prop="account" label="账号"> </el-table-column>
            <el-table-column prop="onTime" label="服务时间" min-width="180">
              <template slot-scope="scope">
                {{ scope.row.onTime }} - {{ scope.row.offTime }}
              </template>
            </el-table-column>
            <el-table-column prop="descr" label="说明"> </el-table-column>
            <el-table-column prop="utime" label="时间" min-width="180"> </el-table-column>
            <el-table-column prop="status" label="状态">
              <template slot-scope="scope">
                <el-switch
                    :disabled="statusShow"
                  v-model="scope.row.status"
                  :active-value="1"
                  :inactive-value="0"
                  @change="handleSwitch(scope.row.customerServiceId)"
                ></el-switch>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="180">
              <template slot-scope="scope">
                <el-button
                    v-if="editShow"
                  @click="handleClick('change', scope.row)"
                  plain
                  size="small"
                  >修改</el-button
                >
                <el-button
                    v-if="deleteShow"
                  type="primary"
                  plain
                  size="small"
                  @click="del(scope.row.customerServiceId)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="roleRight_pagenation">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.pageNo"
            :page-sizes="[PAGE_SIZE, 15, 20, 25]"
            :page-size="page.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="page.count"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 编辑弹框 -->
    <el-dialog
      :title="clickType == 'addNext' ? '新增客服信息' : '修改客服信息'"
      :visible.sync="dialogVisible"
      :close-on-click-modal='false'

      width="460px"
      class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
          ref="ruleForm"
          :rules="rules"
          :model="params"
          label-width="80px"
        >
          <el-form-item
            v-if="clickType == 'addNext' || clickType == 'change'"
            class="item"
            label="类型"
            prop="sex"
          >
            <el-select
              v-model="params.serviceType"
              clearable
              filterable
              placeholder="选择客服类型"
            >
              <el-option
                v-for="item in kefuList"
                :key="item.enumId"
                :label="item.enumName"
                :value="item.enumVal"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="二维码">
            <div class="diplay" style="margin-right: 10px">
              <div class="screenshot">
                <span
                    v-for="(imgUrl, index) in srcList"
                    :key="index"
                    class="slideshow"
                >
                  <el-image
                      style="width: 75px; height: 75px; border-radius: 6px"
                      :src="imgUrl"
                      fit="cover"
                      @click="getPolicy"
                  />
                </span>
                <div
                    class="up-btn"
                    style="width: 75px; height: 75px; line-height: 80px"
                    @click="getPolicy"
                    v-if="isMoer && !params.qrcode"
                >
                  <i class="el-icon-plus"></i>
                </div>
              </div>
              <input
                  type="file"
                  ref="file"
                  @change="getFile"
                  accept="image/png,image/jpg"
              />
            </div>
          </el-form-item>

          <el-row v-if="clickType == 'addNext' || clickType == 'change'">
            <el-col :span="24">
              <el-form-item class="item" required label="名称" prop="name">
                <el-input
                  type="text"
                  v-model="params.name"
                  clearable
                  placeholder="请输入客服名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item class="item" required label="账号" prop="account">
                <el-input
                  maxlength="11"
                  clearable
                  v-model="params.account"
                  placeholder="请输入账号"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item
            label="活动时间"
            required
            v-if="clickType == 'addNext' || clickType == 'change'"
          >
            <el-col :span="10">
              <el-form-item prop="onTime">
                <el-time-picker
                  placeholder="开始时间"
                  v-model="params.onTime"
                  value-format="HH:mm:ss"
                  style="width: 100%"
                ></el-time-picker>
              </el-form-item>
            </el-col>
            <el-col class="line" style="text-align: center" :span="2">
              -
            </el-col>
            <el-col :span="10">
              <el-form-item prop="offTime">
                <el-time-picker
                  placeholder="结束时间"
                  value-format="HH:mm:ss"
                  v-model="params.offTime"
                  style="width: 100%"
                ></el-time-picker>
              </el-form-item>
            </el-col>
          </el-form-item>

          <el-form-item
            v-if="clickType == 'addNext' || clickType == 'change'"
            class="item"
            label="说明"
          >
            <el-input type="textarea" maxlength="200" :rows="4" placeholder="最长为200个字符" v-model="params.descr"></el-input>
            
          </el-form-item>


        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
          >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
          >提 交</el-button
        >
      </span>
    </el-dialog>
  </section>
</template>
<script>
import { PAGE_SIZE } from "@/config";
import {ossUpload} from "@utils/filters/upload";
export default {
  data() {
    return {
      PAGE_SIZE,
      enumCode: "KEFU_TYPE",
      kefuList: [], //客服类型
      onTime: "",
      offTime: "", //客服开始和结束时间
      loading: false,
      // 分页
      page: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },

      search: {},

      dialogVisible: false, //弹出框显示隐藏
      clickType: "", //弹窗类型
      params: {
        qrcode:''
      }, //弹窗修改数据
      rules: {
        name: [{ required: true, message: "请填写客服名称" }],
        account: [{ required: true, message: "请填写账号" }],
        offTime: [{ required: true, message: "请填写结束时间" }],
        onTime: [{ required: true, message: "请填写开始时间" }],
      }, //表单验证提示

      tableData: [], //二级--客服列表

      addShow: false,
      deleteShow: false,
      editShow: false,
      statusShow: true,
      searchShow: false,
      srcList:[],
      isMoer:true
    };
  },
  created() {
    this.getkefuList();
    this.getserviceList();
    this.getPermissionButtonList()
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {
          qrcode:''
        };
        this.isMoer = true
        this.srcList = []
      }
    },
  },
  methods: {
    getPolicy() {
      this.$refs.file.dispatchEvent(new MouseEvent("click"));
    },

    async getFile() {
      const that = this;
      const {data: resData} = await this.$get("/aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.file.files[0],
          resData.data,
          "one", //'more','one'
          this.srcList
      );
      this.isMoer = false;
      this.srcList = addRoutes;
      this.params.qrcode = JSON.parse(JSON.stringify(this.srcList[0]));
    },

    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'kefu:cfg:query') {
            this.searchShow = true
          }
          if (item.code == 'kefu:cfg:add') {
            this.addShow = true
          }
          if (item.code == "kefu:cfg:delete") {
            this.deleteShow = true
          }
          if (item.code == "kefu:cfg:edit") {
            this.editShow = true
          }
          if(item.code == "kefu:cfg:status"){
            this.statusShow = false
          }
        })
      }
    },

    // 获取客服类型
    async getkefuList() {
      const { data: orgData } = await this.$get(`/enums/list/${this.enumCode}`);
      this.kefuList = orgData.data;
    },
    SearchServiceList(){
      this.page.pageNo = 1
      this.getserviceList()
    },
    //客服列表
    async getserviceList() {
      this.loading = true;
      const { data: res } = await this.$get(
        `/customer/service/list`,
        { params: { ...this.search, ...this.page } },
        {
          headers: {
            isLoading: true,
          },
        }
      );
      this.loading = false;
      this.tableData = res.data;
      this.page.count = res.page.count;
    },

    //switch状态改变 --接口 修改客服状态
    handleSwitch(index) {
      this.$put(`/customer/service/info/status/${index}`).then(res=>{
        if(res.data.result==200){
          this.$message.success('操作成功')
        }
      });
    },

    // 弹窗
    handleClick(type, row = {}) {
      this.clickType = type;
      this.dialogVisible = true;
      if (type == "change") {
        this.srcList = []
        this.params =JSON.parse(JSON.stringify(row)) ; //这里修改了
        this.params.qrcode = ''
        if(row.qrcode){
          this.params.qrcode = row.qrcode
          this.srcList[0] = JSON.parse(JSON.stringify(row.qrcode))
        }
      } else {
        //添加
        this.params = {};
        this.srcList = []
      }
    },
    //窗口--提交 修改信息
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        if(this.params.qrcode){
          this.$confirm("确认提交修改, 是否继续?", "提示", {
            type: "info",
          }).then(async () => {
            if (this.clickType == "addNext") {
              const { data: resData } = await this.$post(
                  "/customer/service/info",
                  this.params,
                  {
                    headers: {
                      isLoading: true,
                    },
                  }
              );
              if (resData.result != 200) return;
              this.getserviceList();
              this.dialogVisible = false; //弹窗隐藏
              this.$message.success("添加成功!");
            } else {
              const { data: resData } = await this.$put(
                  "/customer/service/info",
                  this.params,
                  {
                    headers: {
                      isLoading: true,
                    },
                  }
              );
              if (resData.result != 200) return;
              this.getserviceList();
              this.dialogVisible = false; //弹窗隐藏
              this.$message.success("修改成功!");
            }
          });
        }else {
          this.$message.error('请上传二维码')
        }
      });
    },

    //删除 客服
     del(id) {
      this.$confirm("此操作将永久删除该客服, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const { data: resData } = await this.$delete(
            `/customer/service/info/${id}`,
            {
              headers: {
                isLoading: true,
              },
            }
          );
          if (resData.result != 200) return;
          this.getserviceList();

          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    //重置密码
     reset(row) {
      this.$confirm("此操作将会重置登录密码, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async() => {
          const { data: resData } = await this.$put(
            `/service/reset/pwd/${row.serviceId}`,
            {
              headers: {
                isLoading: true,
              },
            }
          );
          if (resData.result != 200) return;
          this.getserviceList();

          this.$message({
            type: "success",
            message: "已重置!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },

    //分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getserviceList();
    },
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getserviceList();
    },
  },
};
</script>
